// extracted by mini-css-extract-plugin
export default {"textContainer":"TextContainer_textContainer__drvTm"};